<div class="action-buttons" [class]="customClass" [ngClass]="'align-' + alignment">
    <button
        *ngFor="let button of buttons"
        id="{{button.id || ''}}"
        [type]="button.htmlType || 'button'"
        [class]="getButtonClass(button) + ' ' + (button.size ? 'btn-' + button.size : '')"
        [disabled]="button.disabled || false"
        (click)="onButtonClick(button)">
        <span *ngIf="button.icon && button.iconPos === 'left'" [class]="'pi ' + button.icon"></span>
        {{ button.label }}
        <span *ngIf="button.icon && button.iconPos === 'right'" [class]="'pi ' + button.icon"></span>
    </button>
</div>
